export default {"src":"/_next/static/media/email.c7c6581e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};